import React from 'react';
import { useNavigate } from 'react-router-dom';
import telegram from '../utils/telegram';
import Header from '../components/Header';
import './Downloads.css';

function Downloads() {
  const navigate = useNavigate();

  const downloads = [
    {
      platform: 'iOS',
      logo: '/images/platforms/apple.png',
      link: 'https://apps.apple.com/ru/app/happ-proxy-utility-plus/id6746188973',
      description: 'App Store (Россия)'
    },
    {
      platform: 'Android',
      logo: '/images/platforms/android.png',
      link: 'https://play.google.com/store/apps/details?id=com.happproxy',
      description: 'Google Play'
    },
    {
      platform: 'Android TV',
      logo: '/images/platforms/android.png',
      link: 'https://play.google.com/store/apps/details?id=com.happproxy',
      description: 'Google Play для TV'
    },
    {
      platform: 'Windows',
      logo: '/images/platforms/windows.png',
      link: 'https://github.com/Happ-proxy/happ-desktop/releases/latest/download/setup-Happ.x64.exe',
      description: 'Прямая загрузка'
    }
  ];

  const openLink = (url) => {
    telegram.hapticMedium();
    telegram.openLink(url);
  };

  return (
    <div className="downloads-page">
      <Header
        title="📥 Скачать Happ"
        subtitle="Выберите вашу платформу"
        onBack={() => navigate('/')}
      />

      <div className="downloads-content">
        <div className="happ-logo-section">
          <img
            src="/images/providers/happ-logo.png"
            alt="Happ Logo"
            className="happ-logo"
          />
          <div className="happ-info">
            <h2>Happ Proxy Utility</h2>
            <p>Современное средство для защиты интернета</p>
          </div>
        </div>

        <div className="platforms-list">
          {downloads.map((item, index) => (
            <div
              key={index}
              className="platform-card"
              onClick={() => openLink(item.link)}
            >
              <img
                src={item.logo}
                alt={item.platform}
                className="platform-logo"
              />
              <div className="platform-info">
                <h3 className="platform-name">{item.platform}</h3>
                <p className="platform-description">{item.description}</p>
              </div>
              <div className="download-arrow">→</div>
            </div>
          ))}
        </div>

        <div className="instructions-section">
          <h3>📱 Как использовать</h3>
          <ol>
            <li>Скачайте Happ для вашей платформы</li>
            <li>Установите приложение</li>
            <li>В разделе "Подбор конфигурации" создайте ссылку</li>
            <li>Нажмите "Открыть в Happ" для автоматической настройки</li>
            <li>Или скопируйте ссылку и добавьте вручную в Happ</li>
          </ol>
        </div>
      </div>
    </div>
  );
}

export default Downloads;
